import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Icon, Label } from 'semantic-ui-react';
// import { getVocabulary } from '@plone/volto/actions/vocabularies/vocabularies';
import { getVocabulary } from '../../../actions/vocabularies/vocabularies';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
function TaconomyFilterListEntry(props) {
  const { facet, isEditMode, setFacets, facets } = props;
  const { locale } = useSelector((state) => state.intl);

  const dispatch = useDispatch();
  React.useEffect(() => {
    if (facet === 'taxonomy_region') {
      dispatch(
        getVocabulary({
          vocabNameOrURL: 'collective.taxonomy.region',
          size: 200,
          locale,
        }),
      );
    }
    if (facet === 'taxonomy_type') {
      dispatch(
        getVocabulary({
          vocabNameOrURL: 'collective.taxonomy.type',
          size: 200,
          locale,
        }),
      );
    }
    if (facet === 'taxonomy_companytype') {
      dispatch(
        getVocabulary({
          vocabNameOrURL: 'collective.taxonomy.companytype',
          size: 200,
          locale,
        }),
      );
    }
    if (facet === 'taxonomy_context') {
      dispatch(
        getVocabulary({
          vocabNameOrURL: 'collective.taxonomy.context',
          size: 200,
          locale,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const vocabularies = useSelector((state) => state.vocabularies);
  const vocabularyNames = {
    taxonomy_type: 'collective.taxonomy.type',
    taxonomy_companytype: 'collective.taxonomy.companytype',
    taxonomy_region: 'collective.taxonomy.region',
    taxonomy_context: 'collective.taxonomy.context',
  };

  const type_values =
    vocabularies[vocabularyNames['taxonomy_type']] &&
    vocabularies[vocabularyNames['taxonomy_type']].loaded
      ? vocabularies?.[vocabularyNames['taxonomy_type']].items.reduce(
          (previous, current) => {
            return { ...previous, [current.value]: current.label };
          },
          {},
        )
      : {};

  const region_values =
    vocabularies[vocabularyNames['taxonomy_region']] &&
    vocabularies[vocabularyNames['taxonomy_region']].loaded
      ? vocabularies?.[vocabularyNames['taxonomy_region']].items.reduce(
          (previous, current) => {
            return { ...previous, [current.value]: current.label };
          },
          {},
        )
      : {};

  const companytype_values =
    vocabularies[vocabularyNames['taxonomy_companytype']] &&
    vocabularies[vocabularyNames['taxonomy_companytype']].loaded
      ? vocabularies?.[vocabularyNames['taxonomy_companytype']].items.reduce(
          (previous, current) => {
            return { ...previous, [current.value]: current.label };
          },
          {},
        )
      : {};

  const context_values =
    vocabularies[vocabularyNames['taxonomy_context']] &&
    vocabularies[vocabularyNames['taxonomy_context']].loaded
      ? vocabularies?.[vocabularyNames['taxonomy_context']].items.reduce(
          (previous, current) => {
            return { ...previous, [current.value]: current.label };
          },
          {},
        )
      : {};

  const taxonomyValues = {};

  taxonomyValues['taxonomy_type'] = type_values;
  taxonomyValues['taxonomy_companytype'] = companytype_values;
  taxonomyValues['taxonomy_region'] = region_values;
  taxonomyValues['taxonomy_context'] = context_values;

  return typeof facets[facet] === 'string' ? (
    <Label size="small">
      {Object.keys(vocabularyNames).includes(facet)
        ? taxonomyValues[facet][facets[facet]]
        : facets[facet]}
      <Icon
        name="delete"
        onClick={() => {
          !isEditMode &&
            setFacets({
              ...facets,
              [facet]: '',
            });
        }}
      />
    </Label>
  ) : (
    <>
      {facets[facet].map((entry, i) => (
        <Label size="small" key={i}>
          {Object.keys(vocabularyNames).includes(facet)
            ? taxonomyValues[facet][entry]
            : entry}{' '}
          <FontAwesomeIcon
            icon={faXmark}
            onClick={() => {
              const entries = facets[facet].filter((item) => item !== entry);
              !isEditMode &&
                setFacets({
                  ...facets,
                  [facet]: entries,
                });
            }}
          />
        </Label>
      ))}
    </>
  );
}

export default TaconomyFilterListEntry;
